import React, { useState, useEffect } from "react";
import Form from "./Form";
import { SignUpData, updatePassword } from "../../firebase/users";
import { ChangePasswordData } from "../../firebase/users";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../firebase/AuthProvider";
import {
  toSignUpDataObject,
  getPrivateUserProfile,
  updateUserProfile,
} from "../../firebase/users";
import Notification from "../shared/TemporaryNotification";
import Spinner from "../shared/Spinner";

interface Props {
  userId: string;
}

type StatusType = "form" | "loading" | "notifysuccess" | "notifyerror";

export default function Edit({ userId }: Props) {
  const { t } = useTranslation();
  const [userProfileData, setUserProfileData] = useState<SignUpData | null>(
    null
  );
  const { user } = useAuth();
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [status, setStatus] = useState<StatusType>("form");
  // const [currentPassword, setCurrentPassword] = useState<string>("");

  useEffect(() => {
    async function fetch() {
      const privateUserProfile = await getPrivateUserProfile(userId);

      if (!privateUserProfile) return;

      const userProfileData = toSignUpDataObject(privateUserProfile);
      setUserProfileData(userProfileData);
    }
    fetch();
  }, [userId]);

  async function save(signUpData: SignUpData) {
    setIsLoading(true);
    // When user sets new password, only set new password
    if (
      signUpData.newPassword &&
      signUpData.newPassword !== "" &&
      signUpData.currentPassword &&
      signUpData.currentPassword !== ""
    ) {
      const email = user?.email ? user.email : "";
      const changepasswordData = {
        currentPassword: signUpData.currentPassword,
        newPassword: signUpData.newPassword,
        email: email,
      };
      const success = await setNewPassword(changepasswordData);
      success ? setSuccess(true) : setError(true);
    } else {
      await updateUserProfile(userId, signUpData);
      setSuccess(true);
    }
    setIsLoading(false);
  }

  async function setNewPassword(changePasswordData: ChangePasswordData) {
    changePasswordData.email = user?.email ? user.email : "";

    setStatus("loading");

    const success = await updatePassword(changePasswordData);
    return success;
  }

  return (
    <>
      <Spinner isVisible={isLoading} />

      {success && (
        <Notification
          message={t("editprofile.successful")}
          handleClose={() => setSuccess(false)}
          timeoutInSeconds={5}
        />
      )}

      {error && (
        <Notification
          message={t("editprofile.error")}
          handleClose={() => setError(false)}
          timeoutInSeconds={5}
        />
      )}

      {userProfileData && (
        <Form
          save={save}
          initialValues={userProfileData}
          showTermsCheckbox={false}
          showEmailField={true}
          showPasswordField={false}
          submitButtonText={t("editprofile.submit")}
        />
      )}
    </>
  );
}
